import api from "@/lib/api";
import type { AboutListParams, ApiAbout, ApiAboutIcon } from "../types";
import type { PaginatedQueryResult } from "@/types";

const ABOUT_ENDPOINTS = {
  LIST: "/cms/about/",
  CREATE: "/cms/about/",
  ICONS: "/cms/about/icons",
  DETAIL: (id: string) => `/cms/about/${id}/`,
};

type AboutCreationPayload = Omit<ApiAbout, "id" | "created_at" | "updated_at">;
type AboutUpdatePayload = Partial<AboutCreationPayload>;

export class AboutHttpRepository {
  async fetchList(
    params?: AboutListParams,
  ): Promise<PaginatedQueryResult<ApiAbout>> {
    const result = await api.get(ABOUT_ENDPOINTS.LIST, { params });
    return result.data;
  }

  async create(payload: AboutCreationPayload): Promise<ApiAbout> {
    const result = await api.post(ABOUT_ENDPOINTS.CREATE, payload);
    return result.data;
  }

  async fetchOne(id: string): Promise<ApiAbout> {
    const result = await api.get(ABOUT_ENDPOINTS.DETAIL(id));
    return result.data;
  }

  async update(id: string, payload: AboutUpdatePayload): Promise<ApiAbout> {
    const result = await api.patch(ABOUT_ENDPOINTS.DETAIL(id), payload);
    return result.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(ABOUT_ENDPOINTS.DETAIL(id));
  }

  async fetchIcons(): Promise<ApiAboutIcon[]> {
    const result = await api.get(ABOUT_ENDPOINTS.ICONS);
    return result.data;
  }
}
